<template>
  <div class="row banco-de-talentos">
    <div class="col-12">

      <div class="row top">
        <div class="col-12">
          <div class="d-flex flex-column align-items-center">
            <router-link to="/">
              <img src="@/assets/images/logo-talentos-na-pista.svg" alt="Talentos na Pista Logotipo" style="height: 80px;">
            </router-link>
            <h1>Preencha os campos abaixo para se candidatar:</h1>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 mx-auto">
          <FormPersonalData ref="formPersonalData" />
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 mx-auto">
          <hr />
        </div>
      </div>

      <div class="row pt-3 pb-5">
        <div class="col-12 col-md-6 mx-auto">
          <p class="lgpd">Seus dados estão seguros com a gente pela <a href="https://99jobs.com/pages/lgpd" target="_blank">Lei Geral de Proteção de Dados</a>.</p>
        </div>
      </div>

      <div class="row mb-5 pb-5">
        <div class="col-12 text-center">
          <button
            @click="trySubmit()"
            class="btn btn-lg px-5 btn-wl-primary rounded-xl shadow"
            :disabled="isSaving"
          >
            <span v-if="!isSaving">{{
              hasTests
                ? "Próxima Etapa"
                : "CADASTRAR"
            }}</span>
            <EllipsisLoader v-else />
          </button>
        </div>
      </div>

      <div class="row bottom">
        <div class="col-12">
          <div class="d-flex justify-content-center">
            <router-link to="/">
              <img src="@/assets/images/logo-powered-2.png" alt="Talentos na Pista Logotipo" style="height: 120px;">
            </router-link>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import FormPersonalData from "ninenine-white-label/src/components/PersonalData/FormPersonalData.vue";
import EllipsisLoader from "ninenine-white-label/src/components/Loader/EllipsisLoader.vue";

export default {
  name: "BancoDeTalentos",

  data() {
    return {
      isSaving: false,
    };
  },

  computed: {
    hasTests() {
      return (
        this.$store.state.opportunities.currentOpportunity &&
        this.$store.state.opportunities.currentOpportunity.opportunity_tests &&
        this.$store.state.opportunities.currentOpportunity.opportunity_tests
          .length > 0
      );
    },

    showIndicationForm() {
      return (
        this.$store.state.opportunities.currentOpportunity &&
        this.$store.state.opportunities.currentOpportunity.indication_domains &&
        this.$store.state.opportunities.currentOpportunity.indication_domains.length > 0
      )
    }
  },

  components: {
    FormPersonalData,
    EllipsisLoader
  },

  mounted() {
    this.getOpportunity()

    setTimeout(() => {
      document.querySelector('.fullname-container input').setAttribute('tabindex', "1")
      document.querySelector('.email-container input').setAttribute('tabindex', "2")
      document.querySelector('.phone-container input').setAttribute('tabindex', "3")
      document.querySelector('.birthday-container input').setAttribute('tabindex', "4")
      document.querySelector('.document-container input').setAttribute('tabindex', "5")
      document.querySelector('.zipcode-container input').setAttribute('tabindex', "6")
      document.querySelector('.form-questions-container input').setAttribute('tabindex', "7")
    }, 2000)
  },

  methods: {
    getOpportunity() {
      const get = () => {
        this.$store
          .dispatch("opportunities/getOpportunity", this.$route.params.id)
          .then((opportunity) => {
            if (opportunity) {
              this.opportunity = opportunity;

              if(this.opportunity.internal_recruitment){
                this.$swal({
                  title: "Uoops",
                  html: "Oportunidade exclusiva para Recrutamento Interno",
                  type: "error",
                });
                this.$router.push(`/vagas`);
                return false;
              }

              if (this.opportunity.status_id != 1 && this.$route.name != "capa-teste") {
                this.$swal({
                  title: "Uoops",
                  html: "Inscrições Encerradas",
                  type: "error",
                });
                this.$router.push(`/vagas/${this.$route.params.id}`);
                return false;
              }
            } else {
              this.notFound = true;
            }
          });
      };

      get();
    },

    validateBasicInfo() {
      let canSubmit = false;

      this.$EventBus.$emit("storePersonalDataForm");
      if (this.$store.state.personalDataForm.error) {
        canSubmit = false;
      } else {
        this.$EventBus.$emit("storeQuestions");

        if (this.$store.state.opportunityQuestionsForm.error) {
          canSubmit = false;
        } else {
          canSubmit = true;

          if(this.$store.state.opportunities.currentOpportunity.pcd == true && this.$store.state.personalDataForm.data.has_disability == false) {
            canSubmit = false;
            this.$swal(
              "Uoops",
              "Oportunidade exclusiva para Pessoas com Deficiência (PCD)",
              "error"
            );
          } else {
            canSubmit = true;
          }
        }
      }

      return canSubmit;
    },

    async trySubmit() {
      let canSubmit = false;

      canSubmit = this.validateBasicInfo();

      if (canSubmit) {
        this.isSaving = true;
        const personalData = this.$store.state.personalDataForm.data;
        personalData.source = " ";
        const savePersonal = personalData ? await this.$store.dispatch("user/personalDataUpdate", personalData) : null;

        if (savePersonal && savePersonal.error) {
          this.isSaving = false;
          this.$swal(
            "Uoops",
            "Ocorreu um erro ao salvar suas informações",
            "error"
          );
          return;
        } else {
          if (!this.hasTests) {
            this.isSaving = true;
            await this.subscribeUser();
            this.isSaving = false;
          } else {
            this.isSaving = false;
            this.$router.push(`/vagas/${this.$route.params.id}/inscricao/testes`);
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .banco-de-talentos{
    min-height: 100vh;
    background-color: #F5F5F5;

    p.lgpd{
      font-size: 12px;
      font-weight: normal;
      text-align: center;

      a{
        color: theme-color('wl-secondary');
        font-weight: bold;
      }
    }

    .top{
      background-color: theme-color('wl-secondary');
      border-bottom-left-radius: 15px;
      border-bottom-right-radius: 15px;
      margin-bottom: 40px;
      padding: 40px 25px;

      img{
        margin-bottom: 15px;
      }

      h1{
        color: theme-color('wl-primary');
        font-size: 18px;
      }
    }

    /deep/ .form-row{
      .selectize-input{
        border-radius: 30px;
      }

      .form-group{
        width: 100%;
        max-width: 100%;
        flex: 0 0 100%;

        .form-control{
          border-radius: 30px;
        }

        &.pronoun-container,
        &.socialName-container,
        &.raceAndEthnicity-container,
        &.gender-container,
        &.sexualOrientation-container,
        &.nationality-container,
        &.personalIncome-container,
        &.familyIncome-container,
        &.marital-status-container,
        &.disability-container,
        &.street-container,
        &.number-container,
        &.complement-container,
        &.neighborhood-container,
        &.state-container,
        &.city-container,
        &.resume-container,
        &.divider-container{
          display: none !important;
        }

        &.fullname-container { order: 0; }
        &.email-container { order: 1; }
        &.phone-container { order: 2; }
        &.birthday-container { order: 3; }
        &.document-container { order: 4; }
        &.zipcode-container { order: 5; }
      }

      .form-questions-container{
        order: 6;
        .form-group{
          label{
            font-size: 18px;
            color: theme-color(wl-secondary);
            font-weight: bold;
            margin: 15px 0 0 0;
          }

          .custom-control{
            width: 100%;
            padding-left: 30px;
          }

          .custom-control-input:checked ~ .custom-control-label::before{
            background-color: theme-color(wl-secondary);
            border-color: theme-color(wl-secondary);
          }

          .custom-radio .custom-control-input:checked ~ .custom-control-label::after{
            background-image: none;
            background-color: theme-color(wl-secondary);
            border-radius: 50%;
            border: 1px solid #fff;
            transform: scale(0.9);
          }

          .custom-control-label{
            font-size: 16px;
            color: #000000;
            font-weight: normal;

            &:before,
            &:after{
              width: 26px;
              height: 26px;
              left: -30px;
              top: 0;
            }
          }
        }
      }
    }
  }

  .bottom{
    background-color: #D9D9D9;
    padding: 50px;
  }
</style>